import { isApiVisible, observeApiVisibility } from './api-visibility';

export function installDeferredApiLoading(Component, loaders) {
  const prototype = Component.prototype;
  const attach = prototype.attach;
  const destroy = prototype.destroy;
  for (const name of loaders) {
    const load = prototype[name];
    if (typeof load !== 'function') continue;
    prototype[name] = function (...args) {
      if (this.element && !isApiVisible(this)) {
        this.__deferredApiLoads = this.__deferredApiLoads || new Map();
        this.__deferredApiLoads.set(name, args);
        return Promise.resolve();
      }
      this.__deferredApiLoads?.delete(name);
      return load.apply(this, args);
    };
  }
  prototype.attach = function (...args) {
    this.__stopDeferredApiObservation?.();
    const result = attach.apply(this, args);
    this.__stopDeferredApiObservation = observeApiVisibility(this, () => {
      if (!isApiVisible(this)) return;
      for (const [name, values] of this.__deferredApiLoads || []) {
        this.__deferredApiLoads.delete(name);
        this[name](...values);
      }
    });
    return result;
  };
  prototype.destroy = function (...args) {
    this.__stopDeferredApiObservation?.();
    this.__deferredApiLoads?.clear();
    return destroy.apply(this, args);
  };
}
